import "./styles.css";
import { AddressFinder } from "@knocode/address-finder";
import { useEffect } from "react";

export default function App() {
  useEffect(() => {
    AddressFinder.setup({
      inputField: "#line_1",
      outputFields: {
        line_1: "#line_1",
        line_2: "#line_2",
        line_3: "#line_3",
        post_town: "#post_town",
        postcode: "#postcode"
      }
    });
  }, []);

  return (
    <div className="app">
      <h1>UK Address Auto fill Address Form - React</h1>
      <p>
        This react sample uses the{" "}
        <a href="https://www.npmjs.com/package/@knocode/address-finder">
          Knocode address-finder
        </a>{" "}
        npm library to provide <br />
        UK address auto complete form.
      </p>
      <form>
        <label for="line_1">Address Line 1</label>
        <input
          type="text"
          id="line_1"
          placeholder="Start typing your address..."
        />
        <label for="line_2">Address Line 2</label>
        <input type="text" id="line_2" />
        <label for="line_3">Address Line 3</label>
        <input type="text" id="line_3" />
        <label for="post_town">Town or City</label>
        <input type="text" id="post_town" />
        <label for="postcode">Postcode</label>
        <input type="text" id="postcode" />
      </form>
    </div>
  );
}
